import { render, staticRenderFns } from "./AnnouncementSection.vue?vue&type=template&id=5877c56f&scoped=true"
import script from "./AnnouncementSection.vue?vue&type=script&lang=js"
export * from "./AnnouncementSection.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementSection.vue?vue&type=style&index=0&id=5877c56f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877c56f",
  null
  
)

export default component.exports